import { LinkItem } from '../../components/PageHeader';
import { t } from 'ttag';

export const getPageLinks = (): LinkItem[] => [
  { link: '#about', label: t`Om Grantme`, newTab: false },
  { link: '#process', label: t`Process`, newTab: false },
  { link: '#functions', label: t`Funktioner`, newTab: false },
  { link: '#team', label: t`Om oss`, newTab: false },
  { link: '#contact', label: t`Kontakt`, newTab: false },
  {
    link: 'https://admin.grantme.se',
    label: t`Logga in`,
    newTab: true,
    isLoginModal: true,
    eventLink: 'https://event-admin.grantme.se',
  },
];
